<div fxLayout *ngIf="vm$ | async as vm">
  <sbnb-subnav header="Direct">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main
    fxFlex
    [ngClass.lt-md]="{ mobile: true }"
    class="subnav__exists"
    fxLayout="column"
    fxLayoutGap="32px"
    fxLayoutGap.lt-md="0px">
    <ng-container *ngTemplateOutlet="headerSection"></ng-container>

    <!-- Loading -->
    <ng-container *ngTemplateOutlet="loadingSection; context: { vm: vm }"></ng-container>

    <!-- Error -->
    <ng-container *ngTemplateOutlet="errorSection; context: { vm: vm }"></ng-container>

    <!-- No data created yet -->
    <ng-container *ngTemplateOutlet="noDataSection; context: { vm: vm }"></ng-container>

    <!-- Happy path - we have data -->
    <section *ngIf="vm.data?.length > 0 && !vm.loading && !vm.error">
      <ng-template
        *ngIf="!(isMobile$ | async)"
        [ngTemplateOutlet]="desktopTable"
        [ngTemplateOutletContext]="{ vm: vm }"></ng-template>

      <ng-template
        *ngIf="isMobile$ | async"
        [ngTemplateOutlet]="mobileTable"
        [ngTemplateOutletContext]="{ vm: vm }"></ng-template>
    </section>
  </main>
</div>

<ng-template #headerSection>
  <section id="header" fxLayout="column">
    <app-feature-flag-tabs>
      <sbnb-page-header class="!mb-0" navTabs>
        <div class="flex w-full justify-between">
          <h2 class="nomargin flex-1 text-center sbnbDesktop:text-left mb-0">Promo Codes</h2>
          <sbnb-button
            class="absolute right-0 sbnbDesktop:relative"
            size="mini"
            [routerLink]="['/direct/promo-codes/new']">
            +
            <span class="hidden sbnbDesktop:inline-block">&nbsp;Add new</span>
          </sbnb-button>
        </div>
      </sbnb-page-header>

      <div class="flex w-full justify-between">
        <h2 class="nomargin flex-1">Promo Codes</h2>
        <sbnb-button size="mini" [routerLink]="['/direct/promo-codes/new']">+ Add new</sbnb-button>
      </div>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'direct-promo-codes'"></sbnb-helptext-wrapper>
  </section>
</ng-template>

<ng-template #loadingSection let-vm="vm">
  <ng-container *ngIf="vm.loading">
    <mat-spinner [diameter]="32"></mat-spinner>
  </ng-container>
</ng-template>

<ng-template #errorSection let-vm="vm">
  <ng-container *ngIf="vm.error">There was an error loading promo codes.</ng-container>
</ng-template>

<ng-template #noDataSection let-vm="vm">
  <ng-container *ngIf="(!vm.data || vm.data?.length === 0) && !vm.error && !vm.loading">
    <sbnb-no-items text="No promo codes" subtext="You haven't created any promo codes yet."></sbnb-no-items>
  </ng-container>
</ng-template>

<ng-template #desktopTable let-vm="vm">
  <div fxLayout fxLayoutGap="16px" fxHide.lt-md class="rules__rule-header">
    <div fxFlex="0 0 48px">Status</div>
    <div fxFlex>Codes</div>
    <div fxFlex="120px">Discount</div>
    <div fxFlex="120px">Properties</div>
    <div fxFlex="120px">Redemptions</div>
    <div fxFlex="80px"></div>
  </div>

  <a
    *ngFor="let code of vm.data"
    class="rules__rule-container"
    fxLayout
    fxLayoutAlign="start center"
    fxLayoutGap="16px"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start start"
    [routerLink]="['/direct/promo-codes', code.uuid]">
    <div fxFlex="0 0 48px">
      <mat-slide-toggle
        [(ngModel)]="code.enabled"
        (ngModelChange)="updateEnabledStatus(code, $event)"
        (click)="$event.stopPropagation()"></mat-slide-toggle>
    </div>

    <div fxFlex style="overflow: hidden">
      <strong *ngFor="let indCode of code.codes; let isLast = last" class="individual-code">
        {{ indCode }}
        <span *ngIf="!isLast">,</span>
      </strong>
    </div>

    <div fxFlex="120px" class="text__small">
      <span *ngIf="code.discount_type === PromoCodeType.Percentage">{{ code.discount_amount }}%</span>
      <span *ngIf="code.discount_type === PromoCodeType.Fixed">
        {{ code.discount_amount | currency: code.currency : 'symbol' : '1.0-2' }}
      </span>
    </div>

    <div fxFlex="120px" fxLayoutAlign="start center">
      <sbnb-avatar-group [items]="code.property_list" itemsForLabel="Promo code"></sbnb-avatar-group>
    </div>

    <div fxFlex="120px" class="text__small">{{ code.reservations.length }}</div>

    <div fxFlex="80px">
      <img
        *ngIf="code.codes.length > 1; else singleCopy"
        src="/assets/iconography/copy-grey.svg"
        style="width: 36px; height: 36px; padding: 8px"
        alt="Copy"
        matTooltip="Copy code..."
        [matMenuTriggerFor]="codesMenu"
        (click)="$event.preventDefault(); $event.stopPropagation()" />

      <ng-template #singleCopy>
        <img
          src="/assets/iconography/copy-grey.svg"
          style="width: 36px; height: 36px; padding: 8px"
          alt="Copy"
          matTooltip="Copy code"
          ngxClipboard
          [cbContent]="code.codes[0]"
          (click)="codeCopied(); $event.preventDefault(); $event.stopPropagation()" />
      </ng-template>

      <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu" [suppressClick]="true"></sbnb-more-menu-trigger>
      <mat-menu #actionsMenu="matMenu">
        <button mat-menu-item (click)="deletePrompt(code)">Delete</button>
      </mat-menu>

      <mat-menu #codesMenu="matMenu">
        <button
          *ngFor="let indCode of code.codes"
          mat-menu-item
          ngxClipboard
          [cbContent]="indCode"
          (click)="codeCopied()">
          {{ indCode }}
        </button>
      </mat-menu>
    </div>
  </a>
</ng-template>

<ng-template #mobileTable let-vm="vm">
  <a
    *ngFor="let code of vm?.data"
    fxLayout="column"
    [routerLink]="['/direct/promo-codes', code.uuid]"
    fxLayoutGap="6px"
    class="mobile-table">
    <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
      <mat-slide-toggle
        [(ngModel)]="code.enabled"
        (ngModelChange)="updateEnabledStatus(code, $event)"
        (click)="$event.stopPropagation()"></mat-slide-toggle>

      <strong *ngFor="let indCode of code.codes; let isLast = last" class="individual-code">
        {{ indCode }}
        <span *ngIf="!isLast">,</span>
      </strong>
    </div>

    <div fxLayoutGap="4px" fxLayoutAlign="start center">
      <span *ngIf="code.discount_type === 'percentage'">{{ code.discount_amount }}%</span>
      <span *ngIf="code.discount_type === 'fixed'">
        {{ code.discount_amount | currency: code.currency : 'symbol' : '1.0-2' }}
      </span>
      <span>discount,</span>
      <span>{{ code.reservations.length }} redemptions</span>
    </div>

    <div fxLayoutAlign="start center">
      <sbnb-avatar-group [items]="code.property_list" itemsForLabel="Promo code"></sbnb-avatar-group>
    </div>

    <div
      fxLayout="row"
      fxLayoutGap="6px"
      style="padding-top: 12px"
      (click)="$event.preventDefault(); $event.stopPropagation()">
      <sbnb-button size="mini" type="secondary" [matMenuTriggerFor]="codesMenu">Copy code</sbnb-button>
      <sbnb-button size="mini" type="secondary" (clicked)="deletePrompt(code)">Delete</sbnb-button>
    </div>

    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item (click)="deletePrompt(code)">Delete</button>
    </mat-menu>

    <mat-menu #codesMenu="matMenu">
      <button
        *ngFor="let indCode of code.codes"
        mat-menu-item
        ngxClipboard
        [cbContent]="indCode"
        (click)="codeCopied()">
        {{ indCode }}
      </button>
    </mat-menu>
  </a>
</ng-template>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
